module.exports = __webpack_public_path__ + "static/media/stancebeam-icon.9a77bc4a.svg";